import React from 'react';
import {Button, Tooltip} from '@chakra-ui/react';
import {AiOutlineTeam} from "react-icons/ai";

export default function TeamButton({task, ...props}) {
  return (
    <Tooltip
      label={
        task.assigned_user
          ? `Bu alt görev "${task.assigned_user.full_name || task.assigned_user.username}" adlı kullanıcıya atanmış.`
          : task.assigned_to
          ? `Bu alt görev "${task.assigned_to.name}" adlı takıma atanmış.`
          : "Bu alt göreve henüz atama yapılmadı."
      }
      bg='gray.100'
      color="black"
      placement='bottom'
    >
      <Button leftIcon={<AiOutlineTeam />} {...props}>
        { task.assigned_user
          ? (task.assigned_user.full_name || task.assigned_user.username)
          : task.assigned_to
          ? task.assigned_to.name
          : 'Atama Yap' }
      </Button>
    </Tooltip>

  )
}
